"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  tooltip: ({
    theme
  }) => ({
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
    boxShadow: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'normal',
    maxWidth: 300,
    textAlign: 'center',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius
  }),
  arrow: ({
    theme
  }) => ({
    color: theme.palette.grey[200],
    '&:before': {
      boxShadow: 'none'
    }
  })
};
const defaultProps = {
  arrow: true
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTooltip.js.map